import { render, staticRenderFns } from "./AxDataTableCellCheckbox.vue?vue&type=template&id=3b815612&"
import script from "./AxDataTableCellCheckbox.vue?vue&type=script&lang=ts&"
export * from "./AxDataTableCellCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./AxDataTableCellCheckbox.vue?vue&type=style&index=0&id=3b815612&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports